import React from 'react'

import { Layout } from './layouts/Layout'
import { Providers } from './Providers'
import { AppRouter } from './routing/AppRouter'

const MswDevTools = React.lazy(() => import('./components/shared/MswDevTools'))

export const App = (): JSX.Element => {
  return (
    <Providers>
      <Layout>
        <AppRouter></AppRouter>
        {process.env['NODE_ENV'] === 'development' && process.env['IS_MSW'] ? (
          <React.Suspense fallback={null}>
            <MswDevTools />
          </React.Suspense>
        ) : null}
      </Layout>
    </Providers>
  )
}
